
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/be-inspired",
      function () {
        return require("private-next-pages/be-inspired/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/be-inspired"])
      });
    }
  